import vocal from './images/vocal.png';
import guitar from './images/guitar.png';
import bass from './images/bass.png';
import drum from './images/drum.png';
import grass from './images/grass.png';

export const data = {
  camAt: [120,-20,120],
  camEye : [
    {pos:[-5,120,220],angle:90},
    {pos:[-10,90,140],angle:110},
    {pos:[-130,70,120],angle:120},
    {pos:[120,70,110],angle:60},
    {pos:[20,70,140],angle:80},
  ],
  images : [
    {img:vocal,size:[160,500]},
    {img:guitar,size:[420,500]},
    {img:bass,size:[310,500]},
    {img:drum,size:[500,500]},
    {img:grass,size:[800,300]}
  ],
  imagePos : [
    {img:0,pos:[30,0,10],cam:1},
    {img:1,pos:[-80,0,0],cam:2},
    {img:2,pos:[80,0,0],cam:3},
    {img:3,pos:[-30,0,-10],cam:4},
    {img:4,pos:[0,0,40],cam:0},
    {img:4,pos:[0,0,80],cam:0},
    {img:4,pos:[-90,0,50],cam:0},
    {img:4,pos:[90,0,50],cam:0},
    {img:4,pos:[-100,0,120],cam:0},
    {img:4,pos:[100,0,120],cam:0},
    {img:4,pos:[-110,0,80],cam:0},
    {img:4,pos:[110,0,80],cam:0},
    {img:4,pos:[-110,0,25],cam:0},
    {img:4,pos:[110,0,25],cam:0},
    {img:4,pos:[-160,0,90],cam:0},
    {img:4,pos:[160,0,90],cam:0},
    {img:4,pos:[-190,0,40],cam:0},
    {img:4,pos:[190,0,40],cam:0}
  ],
  text : [
    'キャラクター画像をクリックしてください。草をクリックで初期位置に戻ります。<br />ThreeDwoをプログラミングするには<a href="threedwo.zip">サンプルソース</a>をダウンロードします。',
    '3DデザインできないWebデザイナーでも、疑似3Dで、2D画像だけでWebデザインできます。<br />Webデザイナーの方ならもっといいオリジナルのシーンが作れると思います。',
    'カーソルキーとWASDキーでもカメラ移動できます。',
    'サイト名の由来は「3D2D」→「ThreeDTwoD」→「ThreeDwo」です。',
    '作者のプロフィールサイトです。<br /><a href="https://profile.vixar.jp">https://profile.vixar.jp</a>',
   ]
}
